import router from '../router/index'

export default {
    state: {
        loggedUser: null,
        foundUser: null,
    },
    getters: {
        getUserName(state) {
            if (!state.loggedUser) return ''
            return state.loggedUser.name
        },
        getUserRole(state) {
            if (!state.loggedUser) return ''
            return state.loggedUser.admin
        },
        getFoundUser(state) {
            return state.foundUser
        }
    },
    mutations: {
        setLoggedUser(state, payload) {
            state.loggedUser = payload
        },
        setFoundUser(state, payload) {
            state.foundUser = payload
        }
    },
    actions: {
        async checkUserByLogin(state, payload) {
            const login = payload ? payload : localStorage.getItem('login');
            if (!login) router.push('/')
            await fetch(`${state.rootGetters.getBaseUrl}/users?login=${login}`)
                .then(res => res.json())
                .then(data => {
                    if (!data || !data.length) throw new Error('Can not find any user with that login')
                    state.commit('setLoggedUser', data[0])
                    localStorage.setItem('login', data[0].login)
                })
                .catch(err => {
                    console.log(err)
                    router.push('/')
                    localStorage.removeItem('login')
                })
        },
        async findUser(state, payload) {
            const login = payload ? payload : localStorage.getItem('login');
            await fetch(`${state.rootGetters.getBaseUrl}/users?login=${login}`)
                .then(res => res.json())
                .then(data => {
                    if (!data || !data.length) throw new Error('Can not find any user with that login')
                    state.commit('setFoundUser', data[0]);
                })
        },
        async changeUserData(state, payload) {
            const {newData, id} = payload;
            await fetch(`${state.rootGetters.getBaseUrl}/users/${id}`, {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(newData)
            })
                .then(res => res.json())
                .then(data => {
                    state.commit('setFoundUser', data)
                })

        },
        async addNewData(state, payload) {
            const {newData} = payload;
            await fetch(`${state.rootGetters.getBaseUrl}/users/`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(newData)
            }).then(res => res.json())
        },
        async deleteData(state, payload) {
            const {id} = payload;
            await fetch(`${state.rootGetters.getBaseUrl}/users/${id}`, {
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })

        }
    },
    modules: {}
}
